import React from "react";
import {Typography, Divider} from '@mui/material';
import CollectionsIcon from '@mui/icons-material/Collections';
import DateRangeIcon from '@mui/icons-material/DateRange';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import RuleIcon from '@mui/icons-material/Rule';
import Edit from '@mui/icons-material/Edit';

import NavigationButton from "../NavigationButton";

const styles = {
    sectionHeader: {
        fontSize: '0.7rem'
    },
    divider: {
        my: '0.2rem'
    }
};

export default function ContentMenuSnippet({permissions}) {
    if (!(permissions.canContentManage || permissions.canAdmin)) {
        return null;
    }

    return (
        <>
            <Typography variant="overline" sx={styles.sectionHeader}>Content</Typography>

            <NavigationButton displayName="Definitions" toLink="/content-definitions">
                <CollectionsIcon/>
            </NavigationButton>

            <NavigationButton displayName="Publishing Plans" toLink="/content-publishing-plans">
                <DateRangeIcon/>
            </NavigationButton>

            <NavigationButton displayName="Manage Plans" toLink="/publishing-plans-hierarchy">
                <Edit/>
            </NavigationButton>

            <NavigationButton displayName="Accreditation" toLink="/content-performing-accreditation">
                <AssignmentTurnedInIcon/>
            </NavigationButton>

            <NavigationButton displayName="Accreditation Hierarchy" toLink="/accreditation-hierarchy">
                <RuleIcon/>
            </NavigationButton>

            <NavigationButton displayName="Content Hierarchy" toLink="/content-hierarchy">
                <AccountTreeIcon/>
            </NavigationButton>
            <Divider sx={styles.divider}/>
        </>
    );
}